module.exports = __webpack_public_path__ + "img/Monte_Kope_80.35b1e5fe.jpg";